import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 bg-[#1F1F1F] text-center" data-id="element-69">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
          <p className="text-sm text-[#C9A66B] font-serif italic mb-4" data-id="element-71">
            Privacidad primero. Método después. Acción hoy.
          </p>
          <div className="flex items-center justify-center gap-6 mb-4" data-id="element-72">
            <button onClick={() => setActiveModal('privacy')} className="text-xs text-gray-400 hover:text-[#F6F1E8] transition-colors underline-offset-4 hover:underline" data-id="element-73">
              Política de Privacidad
            </button>
            <span className="text-gray-600 text-xs" data-id="element-74">·</span>
            <button onClick={() => setActiveModal('terms')} className="text-xs text-gray-400 hover:text-[#F6F1E8] transition-colors underline-offset-4 hover:underline" data-id="element-75">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs text-gray-500" data-id="element-76">
            © {new Date().getFullYear()} Método Faceless Spain. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-77">
          <div className="bg-[#FBF9F5] w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-sm shadow-2xl relative" onClick={e => e.stopPropagation()} data-id="element-78">
            {/* Close button */}
            <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-[#5A5651] hover:text-[#1F1F1F] transition-colors" aria-label="Cerrar" data-id="element-79">
              <X size={20} data-id="element-80" />
            </button>

            <div className="p-8 md:p-12" data-id="element-81">
              {activeModal === 'privacy' && <PrivacyContent data-id="element-82" />}
              {activeModal === 'terms' && <TermsContent data-id="element-83" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <div className="space-y-6" data-id="element-84">
      <h2 className="text-2xl font-serif text-[#1F1F1F]" data-id="element-85">
        Política de Privacidad
      </h2>
      <p className="text-sm text-[#5A5651] leading-relaxed" data-id="element-86">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        month: 'long',
        year: 'numeric'
      })}
      </p>

      <div className="space-y-4 text-sm text-[#5A5651] leading-relaxed" data-id="element-87">
        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-88">
          1. Responsable del tratamiento
        </h3>
        <p data-id="element-89">
          Método Faceless Spain es responsable del tratamiento de los datos
          personales recogidos a través de este sitio web, de conformidad con el
          Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica
          3/2018 de Protección de Datos Personales.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-90">
          2. Datos que recogemos
        </h3>
        <p data-id="element-91">
          Recogemos únicamente los datos necesarios para procesar tu compra:
          nombre, dirección de correo electrónico y datos de pago. Los datos de
          pago son gestionados directamente por la pasarela de pago y no se
          almacenan en nuestros servidores.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-92">
          3. Finalidad del tratamiento
        </h3>
        <p data-id="element-93">
          Tus datos se utilizan exclusivamente para: gestionar tu compra y
          entregarte el producto digital adquirido, enviarte comunicaciones
          relacionadas con tu compra, y cumplir con las obligaciones legales
          aplicables.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-94">
          4. Base legal
        </h3>
        <p data-id="element-95">
          El tratamiento de tus datos se basa en la ejecución del contrato de
          compra y, en su caso, en tu consentimiento expreso para comunicaciones
          comerciales.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-96">
          5. Conservación de datos
        </h3>
        <p data-id="element-97">
          Tus datos se conservarán durante el tiempo necesario para cumplir con
          la finalidad para la que fueron recogidos y para cumplir con las
          obligaciones legales aplicables.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-98">
          6. Tus derechos
        </h3>
        <p data-id="element-99">
          Puedes ejercer tus derechos de acceso, rectificación, supresión,
          limitación, portabilidad y oposición enviando un correo electrónico
          con tu solicitud. Responderemos en un plazo máximo de 30 días.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-100">
          7. Cookies
        </h3>
        <p data-id="element-101">
          Este sitio web utiliza cookies técnicas necesarias para su
          funcionamiento y cookies analíticas para mejorar la experiencia del
          usuario. Puedes configurar tu navegador para rechazar las cookies.
        </p>
      </div>
    </div>;
}
function TermsContent() {
  return <div className="space-y-6" data-id="element-102">
      <h2 className="text-2xl font-serif text-[#1F1F1F]" data-id="element-103">
        Términos y Condiciones
      </h2>
      <p className="text-sm text-[#5A5651] leading-relaxed" data-id="element-104">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        month: 'long',
        year: 'numeric'
      })}
      </p>

      <div className="space-y-4 text-sm text-[#5A5651] leading-relaxed" data-id="element-105">
        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-106">
          1. Objeto
        </h3>
        <p data-id="element-107">
          Los presentes términos regulan la compra y uso del producto digital
          "Método Faceless Spain", un ebook en formato PDF con contenido
          formativo sobre creación de contenido anónimo en redes sociales.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-108">
          2. Producto digital
        </h3>
        <p data-id="element-109">
          El producto consiste en un archivo PDF descargable. Tras completar el
          pago, recibirás acceso inmediato al material a través del correo
          electrónico proporcionado. El contenido es para uso personal y no
          transferible.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-110">
          3. Precio y pago
        </h3>
        <p data-id="element-111">
          El precio del producto es el indicado en la página de venta en el
          momento de la compra (impuestos incluidos). El pago se realiza a
          través de pasarelas de pago seguras. Es un pago único, sin
          suscripciones ni cargos recurrentes.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-112">
          4. Garantía de devolución
        </h3>
        <p data-id="element-113">
          Ofrecemos una garantía de satisfacción de 14 días desde la fecha de
          compra. Si no estás satisfecha con el producto, puedes solicitar el
          reembolso completo sin necesidad de justificación, conforme a la
          normativa de consumo vigente.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-114">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-115">
          Todo el contenido del Método Faceless Spain (textos, diseños,
          estructura, metodología) está protegido por derechos de propiedad
          intelectual. Queda prohibida su reproducción, distribución o
          comunicación pública sin autorización expresa.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-116">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-117">
          El contenido del ebook tiene carácter informativo y formativo. Los
          resultados dependen del esfuerzo y dedicación individual. No
          garantizamos ingresos específicos ni resultados concretos.
        </p>

        <h3 className="text-base font-semibold text-[#1F1F1F] font-sans" data-id="element-118">
          7. Legislación aplicable
        </h3>
        <p data-id="element-119">
          Estos términos se rigen por la legislación española. Para cualquier
          controversia, las partes se someten a los juzgados y tribunales del
          domicilio del consumidor.
        </p>
      </div>
    </div>;
}